<template>
    <router-view/>
  </template>
  
  <script>
  export default {
    name: 'App',
    components: {
    },
  }
  </script>
  
  <style>
  
   
  body { 
      margin: 0;
  }
  *, *:before, *:after {
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
  }
  * {
      padding: 0px;
      margin: 0px;
      border: 0px;
      font-family: Satoshi;
      font-style: normal;
  }
  a{
    text-decoration: none;
  }
  ul li {
      list-style: none;
  }
  [class*=__container] {
      max-width: 1440px;
      margin: 0 auto;
      padding-left: 64px;
      padding-right: 64px;
  }
  [class*=__modal] {
      top: 0;
      bottom: 0;
      right: 0;
      left: 0;
      position: fixed;
      z-index: 100;
      visibility: hidden;
      opacity: 0;
      transition: .3s;
  }
  [class*=__modal].active{ 
      visibility: visible !important;
      opacity: 1 !important;
  }
  main{
      margin-top: 66px;
  }
  .flex{
      display: flex;
  }
  .admin__container{
      padding-top: 50px;
      display: flex;
  }
  @media (max-width: 1024px) { 
      [class*=__container] {
          padding-left: 32px;
          padding-right: 32px;
      }
  }
  @media (max-width: 768px) { 
      [class*=__container] {
          padding-left: 20px;
          padding-right: 20px;
      }
      section{
          padding-top: unset !important;
          padding-bottom: 60px !important;
      }
      .breadcrumb__container{
          padding-top: 40px !important;
          padding-bottom: 28px !important;
      }
      .filter__wrapper__container{
          padding-top: unset !important;
          padding-bottom: unset !important;
      }
      .blog__f1__container{
          padding-top: 54px !important;
      }
  }
  </style>
  